import React, { Component } from 'react';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Loader } from 'sa-ui';
import AppRoute from './AppRoute';
import { Helmet } from 'react-helmet';

import './App.scss';
import { loginRoutes, appRoutes } from './routes';
import AppSecurityRoute from './AppSecurityRoute';
import messages from './appMessages';

class App extends Component {
  render() {
    const { user, authorizing, leaving } = this.props;
    const routes = user ? appRoutes : loginRoutes;
    if (authorizing || leaving) {
      return <Loader show />;
    }
    return (
      <div>
        <Helmet>
          <FormattedMessage {...messages.title}>{(txt) => <title>{txt}</title>}</FormattedMessage>
        </Helmet>
        <AppSecurityRoute />
        <Switch>
          {routes.map((route, key) => (
            <AppRoute {...route} key={key} />
          ))}
        </Switch>
      </div>
    );
  }
}

App.propTypes = {
  entering: PropTypes.bool,
  leaving: PropTypes.bool,
  user: PropTypes.object,
};

export default compose(
  withRouter,
  connect(({ login, app }) => ({ ...login, user: app.user })),
)(App);
